"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolParticipantInvitationStatusEnum = exports.CommunityPoolParticipantStatusEnum = exports.CommunityPoolParticipantToJSON = exports.CommunityPoolParticipantFromJSONTyped = exports.CommunityPoolParticipantFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CommunityPoolParticipantFromJSON(json) {
    return CommunityPoolParticipantFromJSONTyped(json, false);
}
exports.CommunityPoolParticipantFromJSON = CommunityPoolParticipantFromJSON;
function CommunityPoolParticipantFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': !(0, runtime_1.exists)(json, '_id') ? undefined : json['_id'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'userEmail': !(0, runtime_1.exists)(json, 'userEmail') ? undefined : json['userEmail'],
        'userName': !(0, runtime_1.exists)(json, 'userName') ? undefined : json['userName'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'invitationStatus': !(0, runtime_1.exists)(json, 'invitationStatus') ? undefined : json['invitationStatus'],
        'totalCreditsUsd': !(0, runtime_1.exists)(json, 'totalCreditsUsd') ? undefined : json['totalCreditsUsd'],
        'creditsBySource': !(0, runtime_1.exists)(json, 'creditsBySource') ? undefined : (0, _1.CommunityPoolParticipantCreditsBySourceFromJSON)(json['creditsBySource']),
        'invitedAt': !(0, runtime_1.exists)(json, 'invitedAt') ? undefined : (new Date(json['invitedAt'])),
        'termsAcceptedAt': !(0, runtime_1.exists)(json, 'termsAcceptedAt') ? undefined : (new Date(json['termsAcceptedAt'])),
        'invitedBy': !(0, runtime_1.exists)(json, 'invitedBy') ? undefined : json['invitedBy'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
        'currentFuelBalance': !(0, runtime_1.exists)(json, 'currentFuelBalance') ? undefined : json['currentFuelBalance'],
        'revokedReason': !(0, runtime_1.exists)(json, 'revokedReason') ? undefined : json['revokedReason'],
    };
}
exports.CommunityPoolParticipantFromJSONTyped = CommunityPoolParticipantFromJSONTyped;
function CommunityPoolParticipantToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'userId': value.userId,
        'userEmail': value.userEmail,
        'userName': value.userName,
        'status': value.status,
        'invitationStatus': value.invitationStatus,
        'totalCreditsUsd': value.totalCreditsUsd,
        'creditsBySource': (0, _1.CommunityPoolParticipantCreditsBySourceToJSON)(value.creditsBySource),
        'invitedAt': value.invitedAt === undefined ? undefined : (value.invitedAt.toISOString()),
        'termsAcceptedAt': value.termsAcceptedAt === undefined ? undefined : (value.termsAcceptedAt.toISOString()),
        'invitedBy': value.invitedBy,
        'adminNotes': value.adminNotes,
        'currentFuelBalance': value.currentFuelBalance,
        'revokedReason': value.revokedReason,
    };
}
exports.CommunityPoolParticipantToJSON = CommunityPoolParticipantToJSON;
/**
* @export
* @enum {string}
*/
var CommunityPoolParticipantStatusEnum;
(function (CommunityPoolParticipantStatusEnum) {
    CommunityPoolParticipantStatusEnum["INVITED"] = "INVITED";
    CommunityPoolParticipantStatusEnum["JOINED"] = "JOINED";
    CommunityPoolParticipantStatusEnum["REVOKED"] = "REVOKED";
})(CommunityPoolParticipantStatusEnum = exports.CommunityPoolParticipantStatusEnum || (exports.CommunityPoolParticipantStatusEnum = {}));
/**
* @export
* @enum {string}
*/
var CommunityPoolParticipantInvitationStatusEnum;
(function (CommunityPoolParticipantInvitationStatusEnum) {
    CommunityPoolParticipantInvitationStatusEnum["INVITED"] = "INVITED";
    CommunityPoolParticipantInvitationStatusEnum["ACCEPTED"] = "ACCEPTED";
    CommunityPoolParticipantInvitationStatusEnum["EXPIRED"] = "EXPIRED";
    CommunityPoolParticipantInvitationStatusEnum["REVOKED"] = "REVOKED";
})(CommunityPoolParticipantInvitationStatusEnum = exports.CommunityPoolParticipantInvitationStatusEnum || (exports.CommunityPoolParticipantInvitationStatusEnum = {}));
